import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UserInfoService } from './user-info.service'
import { CommonService } from './common.service'
import { EnviormentConfig } from '../wcax-env-config';
import { AemService } from './aem.service'

@Injectable()
export class BoxtopService {

    private config = EnviormentConfig;
    public currentEnv = ''

    public constructor(
        private _http: HttpClient, 
        private _userInfoService: UserInfoService,
        private _commonService: CommonService,
        private _aemService: AemService
        ) {
            this.currentEnv = this._commonService.getCurrentEnviorment();
    }

    public getGeneralMillsId(){
        const httpOptions = {headers: new HttpHeaders(this.getPreUcaHttpOptions())};
        const loyaltyPartnersPath = this._aemService.getLoyaltyPartnersPath();
        const  customerId = this._userInfoService.getCustomerId() ? this._userInfoService.getCustomerId() : '1';
        loyaltyPartnersPath?.replace('{customerId}', customerId);
        return this._http.get(loyaltyPartnersPath, httpOptions);
    }

    private getPreUcaHttpOptions(){
        const currentTime = new Date();
        const cncSubscriptionKey = this.config[this.currentEnv]?.datapowerConfig?.cncSubscriptionKey;
        return {
            'Accept': 'application/vnd.safeway.v1+json',
            'X-SWY_BANNER': this._userInfoService.getBanner(),
            'Ocp-Apim-Subscription-Key' : cncSubscriptionKey,
            'Content-Type': 'application/vnd.safeway.v1+json',
            'x-swy-client-id': 'web-portal',
            'x-swy-correlation-id': this._commonService.generateUUID(),
            'x-swy-date': currentTime.toString(),
            'Cache-Control': 'no-cache'
        };
    }
}
